(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3ClubFacility', {
            templateUrl: 'app/club-admin/facility/facility.component.html',
            controller: FacilityComponent,
            bindings: {
                clubId: '<',
                clubFacility: '<'
            }
        });

    var noop = angular.noop;

    FacilityComponent.$inject = ['$rootScope', '$timeout', 'Club', 'facilityType', 'clubAdminResources', 'alert', 'defaultClubLogoUrl', 'user'];
    function FacilityComponent($rootScope, $timeout, Club, facilityType, clubAdminResources, alert, defaultClubLogoUrl, user) {
        var ctrl = this,
            clearLogo = setLogoBlob.bind(ctrl, null);
        
        ctrl.facilityTypeList = [facilityType.Public, facilityType.SemiPublic, facilityType.Private];
        

        // Properties
        ctrl.defaultClubLogo = defaultClubLogoUrl;
        ctrl.isAssociationAdmin = user.isAssociationAdmin;

        // Methods
        ctrl.submit = submit;

        // Logo Methods
        ctrl.onLogoLoad = onLogoLoad;
        ctrl.onLogoError = clearLogo;
        ctrl.onLogoSelect = onLogoSelect;
        ctrl.clearLogo = clearLogo;


        function submit() {
            var clubFacility = ctrl.clubFacility;
            var clubId = ctrl.clubId;
            if (ctrl.form.$valid) {
             
                Club.saveClubFacility({ id: clubId }, clubFacility, success, error, true).$promise;                                        
            }
                        
            function success() {
                ctrl.clubFacility = clubFacility;                                
                alert.success(clubAdminResources.saveFacilitySucceeded);
            }

            function error() {
                alert.error(clubAdminResources.saveFacilityFailed);
            }
        }

        // ** Logo Methods
        function onLogoLoad(e) {
            revokeObjectURL(e.target.src);
        }
        function onLogoSelect(e) {
            var input = e.target,
                file = input.files[0],
                objectUrl = createObjectURL(file),
                image = new Image();

            image.onload = success;
            image.onerror = error;
            image.src = objectUrl;

            function success() {
                var canvas = drawToCanvas(image, 150, 150);
                revokeObjectURL(objectUrl);
                canvas.toBlob(callback, file.type);

                function callback(blob) {
                    blob.name = file.name;
                    $rootScope.$apply(setLogoBlob.bind(ctrl, blob));
                }
            }

            function error() {
                revokeObjectURL(objectUrl);
                alert.error('Invalid image!');
            }
        }

        // Helpers
        function setLogoBlob(blob) {
            var clubFacility = ctrl.clubFacility;
            revokeObjectURL(clubFacility.logoPath);
            clubFacility.logoPath = blob ? createObjectURL(blob) : null;
            clubFacility.logoBlob = blob;
        }
        function drawToCanvas(image, maxWidth, maxHeight) {
            var canvas = document.createElement('canvas'),
                context = canvas.getContext("2d"),
                actualWidth = image.width,
                actualHeight = image.height,
                scale, dataUrl;

            scale = Math.min(maxWidth / actualWidth, maxHeight / actualHeight);
            canvas.width = actualWidth * scale;
            canvas.height = actualHeight * scale;
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            return canvas;
        }

        function revokeObjectURL(url) {
            $timeout(revokeObjectURL, 0, false);

            function revokeObjectURL() {
                if (url && url.startsWith('blob:'))
                    URL.revokeObjectURL(url);
            }
        }

        function createObjectURL(url) {
            return URL.createObjectURL(url);
        }
   
    }
    
})();

